module.exports = __webpack_public_path__ + "static/img/在线问诊@2x1.7b997ade.png";